import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import fr from 'facet-rest';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import ListDetailView from 'Components/UI/ListDetailView';
import { useMeetingContext } from 'Context/MeetingContext';
import { pickImplementation } from 'Helpers/Affordances';
import moment from 'moment-timezone';
import StatusBanner from 'Components/StatusBanner';
import Detail from './DetailView';
import ListItem from './ListItem';
import ListHeader from './ListHeader';
import ListFooter from './ListFooter';

const styles = theme => ({
  root: {
    height: `calc(100vh - ${theme.heights.advisorNavigationHeight}px)`,
    display: 'flex',
    flexDirection: 'column',
  },
  listDetailView: {
    flexGrow: 1,
  },
  list: {
    backgroundColor: theme.palette.facet.lightGray,
  },
  footer: {
    backgroundColor: theme.palette.facet.lightGray,
    borderTop: `1px solid ${theme.palette.grey[400]}`,
    maxHeight: '30%',
    overflowY: 'scroll',
  },
  listDetailViewList: {},
});

const ModularMissionControlCanaryRoot = ({
  className,
  classes,
}) => {
  const { rootNodeProps } = useEventTrackingLogEvent({
    nodeName: 'Mission Control Canary',
    isPageView: true,
  });

  const { setMeetingResource } = useMeetingContext();
  const { householdResource } = useSimpleHousehold();
  const linkUrl = pickImplementation(householdResource, {
    [fr.relationships.default.name]: householdResource?.relationship(fr.relationships.householdMeetings.name).link('related').url({
      params: {
        tz: moment.tz.guess(),
      },
    }),
  });

  return (
    <div
      {...rootNodeProps}
      test={'mission-control-root'}
      className={classNames(classes.root, className)}
    >
      {householdResource ? <StatusBanner resourceLink={householdResource.relationship(fr.relationships.statusBanners.name)?.link('related')} /> : null}
      <ListDetailView
        classes={{
          root: classes.listDetailView,
          listView: classes.listDetailViewList,
        }}
        linkUrl={linkUrl}
        queryValName="meetingSelfLink"
        getSelfLink={(resource) => {
          return resource.link('self').url();
        }}
        onMount={(fetchedResource) => {
          setMeetingResource(fetchedResource);
        }}
        variant={'beside'}
        DetailViewComponent={Detail}
        ListViewListItemComponent={ListItem}
        ListViewListProps={{
          showAlternatingRows: false,
          classes: {
            list: classes.list,
            footer: classes.footer,
          },
          emptyStateIcon: 'dateRange',
          emptyStateTitle: 'No scheduled meetings',
        }}
        ListViewHeaderComponent={ListHeader}
        ListViewFooterComponent={ListFooter}
      />
    </div>
  );
};

ModularMissionControlCanaryRoot.defaultProps = {
  className: '',
};

ModularMissionControlCanaryRoot.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ModularMissionControlCanaryRoot);
